{
  "_meta": {
    "idioma": "es",
    "nombre": "Español",
    "predeterminado": true,
    "_nota": "Solo codigos estables y texto de interfaz. Los literales del proveedor NUNCA se traducen."
  },
  "app": {
    "nombre": "Freight Bridge",
    "suite": "AGS · Suite logística",
    "cargando": "Cargando…",
    "sinResultados": "Sin resultados",
    "idioma": "Idioma",
    "veCosto": "ve costos",
    "noVeCosto": "no ve costos",
    "reintentar": "Reintentar",
    "cerrar": "Cerrar",
    "salir": "Salir",
    "recorte": "Se muestran las {n} más recientes y hay más. Afina la búsqueda o los filtros: lo que no aparece aquí sigue existiendo.",
    "rutaRota": "La dirección «{ruta}» no existe.",
    "rutaRotaDonde": "No se ha cambiado de sitio: sigues en {zona}.",
    "rutaRotaCerrar": "Entendido"
  },
  "modo": {
    "FCL": "Contenedor completo (FCL)",
    "LCL": "Carga consolidada (LCL)",
    "AEREO": "Aéreo",
    "PROYECTO": "Proyecto",
    "TERRESTRE": "Terrestre",
    "FLUVIAL": "Fluvial",
    "FERROVIARIO": "Ferroviario"
  },
  "tramo": {
    "ORIGEN": "Origen",
    "FLETE": "Flete",
    "DESTINO": "Destino",
    "OTRO": "Otro"
  },
  "inclusion": {
    "ADICIONAL": "Adicional",
    "INCLUIDO": "Incluido en el flete",
    "EXCLUIDO_DECLARADO": "Excluido declarado"
  },
  "direccion": {
    "COSTO": "Costo",
    "INGRESO": "Ingreso"
  },
  "terminoEntrega": {
    "CY_CY": "CY / CY",
    "CY_DOOR": "CY / Puerta",
    "DOOR_CY": "Puerta / CY",
    "DOOR_DOOR": "Puerta / Puerta",
    "NO_DECLARADO": "No declarado"
  },
  "alcance": {
    "ALL_IN": "All-in",
    "SOLO_FLETE": "Solo flete",
    "FLETE_MAS_ORIGEN": "Flete más origen",
    "NO_DECLARADO": "No declarado"
  },
  "estadoVigencia": {
    "VIGENTE": "Vigente",
    "VENCIDA": "Vencida",
    "VENCIDA_POR_DEFECTO": "Sin vigencia declarada",
    "ZARPADA": "Zarpó el buque",
    "FUTURA": "Futura"
  },
  "estadoCotizacion": {
    "BORRADOR": "Borrador",
    "ENVIADA": "Enviada",
    "APROBACION_PENDIENTE": "Pendiente de aprobación",
    "ACEPTADA": "Aceptada",
    "RECHAZADA": "Rechazada",
    "VENCIDA": "Vencida"
  },
  "estadoEmbarque": {
    "RESERVADO": "Reservado",
    "EN_ORIGEN": "En origen",
    "EN_TRANSITO": "En tránsito",
    "EN_DESTINO": "En destino",
    "ENTREGADO": "Entregado",
    "CERRADO": "Cerrado"
  },
  "carrier": {
    "titulo": "Carrier",
    "IDENTIFICADO": "Carrier sin nombre en el catálogo",
    "CODIGO_PENDIENTE": "Carrier no revelado",
    "ENMASCARADO": "Carrier enmascarado",
    "NO_DECLARADO": "Carrier no declarado",
    "contrato": "Contrato",
    "servicio": "Servicio",
    "MULTIPLE": "La tarifa la operan dos aerolíneas y el proveedor no dice cuál"
  },
  "estadoCarrier": {
    "IDENTIFICADO": "Identificado",
    "CODIGO_PENDIENTE": "Pendiente de clave",
    "ENMASCARADO": "Enmascarado",
    "NO_DECLARADO": "No declarado",
    "MULTIPLE": "Dos aerolíneas"
  },
  "busqueda": {
    "titulo": "Buscar tarifas vigentes",
    "pol": "Puerto de carga (POL)",
    "pod": "Puerto de descarga (POD)",
    "modo": "Modo",
    "equipo": "Equipo",
    "fechaEmbarque": "Fecha de embarque",
    "buscar": "Buscar",
    "buscando": "Buscando…",
    "pais": "País",
    "sinPais": "Sin país",
    "cambiarPais": "cambiar",
    "escribeParaBuscar": "Escribe dos letras o más",
    "aliasSinConfirmar": "Alias sin confirmar",
    "deReferencia": "referencia",
    "deReferenciaDetalle": "Del catálogo mundial UN/LOCODE, no del catálogo propio: hoy no hay ninguna tarifa cargada contra este punto.",
    "hayMas": "Hay más resultados — sigue escribiendo",
    "campoObligatorio": "Falta este campo",
    "totalResultados": "{n} tarifas",
    "nadaEncontrado": "Ninguna tarifa vigente para esta ruta, equipo y fecha.",
    "sinCostoCatalogo": "Tu usuario no ve costos: cada tarifa muestra sus términos completos, pero los montos no llegan del servidor.",
    "porVia": "resuelto por",
    "aol": "Aeropuerto de origen (AOL)",
    "aod": "Aeropuerto de destino (AOD)",
    "pesoKg": "Peso real (kg)",
    "pesoKgPista": "El de la báscula. Se compara con el que sale del volumen y se cobra el mayor.",
    "volumenM3": "Volumen (m³)",
    "volumenM3Pista": "Obligatorio: sin él no se puede saber cuántos kilos se cobran.",
    "bultos": "Bultos",
    "bultosPista": "Cuántas piezas. No cambia el precio: sirve para comprobar los límites por bulto de cada tarifa.",
    "opcional": "opcional",
    "nBultos": {
      "uno": "1 bulto",
      "otro": "{n} bultos"
    },
    "m3": "m³",
    "escribeParaBuscarAereo": "Escribe el código IATA o dos letras del nombre"
  },
  "desambiguacion": {
    "titulo": "Hay que elegir antes de buscar",
    "NOMBRE_AMBIGUO": "Nombre ambiguo",
    "ALIAS_SIN_CONFIRMAR": "Alias sin confirmar",
    "ALIAS_MULTIPLE": "El alias agrupa varios equipos",
    "SIN_RESOLVER": "No resuelve contra el catálogo",
    "TIPO_INCOMPATIBLE": "No es válido para este modo",
    "elegir": "Usar esta",
    "sinOpciones": "No hay ninguna opción que proponer: corrige el valor y vuelve a buscar."
  },
  "grupo": {
    "titulo": "Alcance {alcance} · Entrega {termino}",
    "comparabilidad": "Los totales solo se comparan dentro de este grupo.",
    "advertencia": "Advertencia de alcance"
  },
  "resultado": {
    "proveedor": "Proveedor",
    "proveedorNoIdentificado": "Proveedor no identificado",
    "total": "Total",
    "sinCosto": "Tu usuario no ve costos",
    "ingreso": "Ingreso del proveedor",
    "neto": "Neto",
    "cargos": "Cargos",
    "cargosFuera": "Fuera del total",
    "diasLibres": "Días libres",
    "demora": "demora",
    "detencion": "detención",
    "minimo": "mínimo negociado",
    "dias": "días",
    "tramo": "Tramo",
    "acciones": "Acciones",
    "transito": "Tránsito",
    "noDeclarado": "No declarado",
    "vigencia": "Vigencia",
    "etd": "ETD",
    "hasta": "hasta",
    "espacio": "Espacio",
    "disponible": "disponible",
    "confianza": "Confianza",
    "notaRevision": "Nota de revisión",
    "restriccion": "Restricción de mercancía",
    "condicionComercial": "Condición comercial",
    "frecuencia": "Frecuencia",
    "cotizar": "Cotizar esta tarifa",
    "verDetalle": "Ver cargos",
    "ocultarDetalle": "Ocultar cargos",
    "condiciones": "Condiciones",
    "motivoFuera": "Motivo"
  },
  "vacio": {
    "inicial": {
      "titulo": "Busca una ruta para empezar",
      "explica": "Elige puerto de carga, puerto de descarga y equipo, y pulsa Buscar. Solo salen tarifas verificadas y vigentes: el catálogo puede tener más de las que aparecen aquí."
    },
    "sinResultados": {
      "titulo": "Ninguna tarifa cotizable para esta búsqueda"
    },
    "rutaDesconocida": {
      "titulo": "Esta ruta no está en el catálogo",
      "explica": "No hay ninguna tarifa cargada para {ruta} en {modo}, ni vigente ni vencida.",
      "hacer": "Comprueba que los dos puertos sean los que querías —hay puertos homónimos en países distintos— y, si lo son, la ruta todavía no ha llegado por correo."
    },
    "hayTarifas": {
      "uno": "Hay 1 tarifa cargada para {ruta}, pero no llega a ser cotizable. Por qué:",
      "otro": "Hay {n} tarifas cargadas para {ruta}, pero ninguna llega a ser cotizable. Por qué:"
    },
    "nTarifas": {
      "uno": "1 tarifa",
      "otro": "{n} tarifas"
    },
    "sinVigencia": "sin declarar",
    "causa": {
      "SIN_VERIFICAR": {
        "titulo": "Sin verificar",
        "explica": {
          "uno": "1 tarifa está cargada, pero nadie ha firmado su documento. Una tarifa sin verificar no llega a una cotización, por buena que sea.",
          "otro": "{n} tarifas están cargadas, pero nadie ha firmado su documento. Una tarifa sin verificar no llega a una cotización, por buena que sea."
        },
        "hacer": "Revísalas y firma el rate sheet. Si le falta un dato del proveedor —el carrier viene codificado, por ejemplo— no se puede firmar hasta que llegue."
      },
      "FUERA_DE_FECHA": {
        "titulo": "Fuera de la fecha",
        "explica": {
          "uno": "1 tarifa está vigente hoy, pero su vigencia no cubre el {fecha} que has pedido: llega hasta el {ultima}.",
          "otro": "{n} tarifas están vigentes hoy, pero su vigencia no cubre el {fecha} que has pedido. La más tardía llega hasta el {ultima}."
        },
        "hacer": "Cambia la fecha de embarque, o pide al proveedor la tarifa del periodo siguiente."
      },
      "EQUIPO_NO_OFRECIDO": {
        "titulo": "Sin ese equipo",
        "explica": {
          "uno": "1 tarifa sirve para esta ruta y esta fecha, pero no ofrece {equipo}. El proveedor lo dejó marcado como no ofrecido, que no es lo mismo que gratis.",
          "otro": "{n} tarifas sirven para esta ruta y esta fecha, pero no ofrecen {equipo}. El proveedor lo dejó marcado como no ofrecido, que no es lo mismo que gratis."
        },
        "hacer": "Prueba con otro equipo, o pide al proveedor precio para {equipo}."
      },
      "VENCIDA": {
        "titulo": "Vencidas",
        "explica": {
          "uno": "1 tarifa ya venció: regía hasta el {ultima}.",
          "otro": "{n} tarifas ya vencieron. La última regía hasta el {ultima}."
        },
        "hacer": "Carga el correo nuevo del proveedor y fírmalo. Extender la vigencia de la vieja sería escribir que el proveedor sostiene un precio que no ha sostenido."
      },
      "SIN_VIGENCIA_DECLARADA": {
        "titulo": "Sin vigencia declarada",
        "explica": {
          "uno": "1 tarifa no dice hasta cuándo rige. Una vigencia ausente cuenta como vencida, no como vigente: si no se sabe, no se cotiza.",
          "otro": "{n} tarifas no dicen hasta cuándo rigen. Una vigencia ausente cuenta como vencida, no como vigente: si no se sabe, no se cotiza."
        },
        "hacer": "Pide al proveedor el periodo de validez y cárgalo."
      },
      "ZARPADA": {
        "titulo": "El buque ya zarpó",
        "explica": {
          "uno": "1 tarifa estaba atada a una salida concreta que ya salió. Una tarifa por ETD muere cuando zarpa ese buque, no al terminar la semana.",
          "otro": "{n} tarifas estaban atadas a una salida concreta que ya salió. Una tarifa por ETD muere cuando zarpa ese buque, no al terminar la semana."
        },
        "hacer": "Pide al proveedor la salida siguiente."
      },
      "FUTURA": {
        "titulo": "Todavía no rigen",
        "explica": {
          "uno": "1 tarifa empieza a regir más adelante, así que hoy no es cotizable aunque cubra la fecha que pides.",
          "otro": "{n} tarifas empiezan a regir más adelante, así que hoy no son cotizables aunque cubran la fecha que pides."
        },
        "hacer": "Vuelve cuando empiecen a regir. Buscar hacia adelante todavía no está: es una limitación conocida del buscador, no un dato que falte."
      },
      "CONSULTA_AL_MOMENTO": {
        "titulo": "Precio a consultar",
        "explica": {
          "uno": "1 tarifa es de referencia: el proveedor no fijó precio y lo da al momento de reservar.",
          "otro": "{n} tarifas son de referencia: el proveedor no fijó precio y lo da al momento de reservar."
        },
        "hacer": "Pide cotización puntual al proveedor para esta ruta y fecha."
      },
      "ESCALON_NO_OFRECIDO": {
        "titulo": "Escalón no ofrecido",
        "explica": {
          "uno": "1 tarifa cubre la ruta y la fecha, pero el escalón de peso que le toca a {peso} kg viene con la barra del proveedor: no lo ofrece. No se cae al escalón vecino, que sería cobrar un precio que nadie dio.",
          "otro": "{n} tarifas cubren la ruta y la fecha, pero el escalón de peso que le toca a {peso} kg viene con la barra del proveedor: no lo ofrecen. No se cae al escalón vecino, que sería cobrar un precio que nadie dio."
        },
        "hacer": "Prueba con otro peso, o pide al proveedor precio para ese escalón."
      },
      "PESO_FUERA_DE_ESCALONES": {
        "titulo": "Peso fuera de los escalones",
        "explica": {
          "uno": "1 tarifa deja {peso} kg fuera de sus escalones, normalmente por debajo del primero. No se extrapola hacia abajo: sería inventar una tarifa.",
          "otro": "{n} tarifas dejan {peso} kg fuera de sus escalones, normalmente por debajo del primero. No se extrapola hacia abajo: sería inventar una tarifa."
        },
        "hacer": "Agrupa más carga, o pide al proveedor precio para ese peso."
      },
      "SIN_RELACION_VOLUMETRICA": {
        "titulo": "Sin relación volumétrica",
        "explica": {
          "uno": "1 tarifa no dice con qué relación convertir {volumen} m³ en kilos, así que no se puede saber cuántos kilos se cobran. No se supone la de IATA.",
          "otro": "{n} tarifas no dicen con qué relación convertir {volumen} m³ en kilos, así que no se puede saber cuántos kilos se cobran. No se supone la de IATA."
        },
        "hacer": "Pide al proveedor la relación volumétrica de esas tarifas y cárgala."
      }
    }
  },
  "bandera": {
    "ALCANCE_NO_DECLARADO": "La tarifa no declara qué incluye: el total está incompleto y no es comparable.",
    "TERMINO_ENTREGA_NO_DECLARADO": "No se sabe si el precio llega a patio o a puerta.",
    "CARGOS_ESTIMADOS": "Algún cargo vino en rango: el total tiene dos cotas.",
    "CARGOS_CONDICIONALES": "Hay cargos que dependen de una condición. No están en el total: léelos y decide.",
    "CARGOS_FUERA_DEL_TOTAL": "Hay cargos que no se pudieron valorar sin conocer la carga.",
    "CONFIANZA_BAJA": "Confianza de extracción por debajo del umbral.",
    "CARRIER_NO_IDENTIFICADO": "Carrier enmascarado, codificado o ausente.",
    "PROVEEDOR_NO_IDENTIFICADO": "El correo no permitía identificar al proveedor.",
    "MULTIMONEDA": "Cargos en más de una moneda. No se suman entre sí.",
    "SIN_FLETE_PARA_EL_EQUIPO": "Para este equipo no hay cargo de flete: es una ruta, no una tarifa.",
    "SUJETA_A_CONFIRMACION": "Sujeta a confirmación del proveedor.",
    "EMBARGO": "Embargo: el carrier no acepta carga en esta ruta ahora mismo. La tarifa vale como referencia y no se puede reservar contra ella.",
    "CONSULTA_CASO_A_CASO": "Hay precio, no hay compromiso de espacio: hay que preguntar por embarque.",
    "SOLO_CARTON": "Solo carga en cartón. Es una restricción de tipo de bulto, no de tamaño.",
    "ESPACIO_APROXIMADO": "La fecha de espacio es aproximada, no un compromiso.",
    "DESPEGA_DE_OTRO_AEROPUERTO": "El vuelo no sale del aeropuerto declarado: hay un tramo terrestre por delante. El tránsito ya lo cuenta, pero la recogida y la salida no son el mismo punto.",
    "RESTRICCION_POR_BULTO": "La tarifa limita el tamaño o el peso por pieza, y no se pudo contrastar con la carga. Léelo antes de cotizar.",
    "BULTO_FUERA_DE_LIMITE": "Los bultos declarados pasan un límite de esta tarifa. No sirve para esta carga, por barata que sea.",
    "COBRA_PESO_VOLUMETRICO": "Se cobran más kilos de los que pesa: manda el peso volumétrico."
  },
  "motivoFuera": {
    "CONDICIONADO": "Depende de una condición",
    "BREAK_DE_PESO": "El precio depende del escalón de peso",
    "BASE_NO_DETERMINABLE": "La base depende de la carga",
    "MONEDA_DISTINTA": "En otra moneda: sin tasa de cambio no se convierte",
    "RANGO_SIN_COTAS": "Sin monto utilizable",
    "ESCALON_NO_ELEGIDO": "Otro escalón de peso: a este peso no aplica",
    "NO_OFRECIDO": "El proveedor no ofrece este escalón",
    "INCLUIDO_EN_FLETE": "Ya viene incluido en el flete: no se suma",
    "EXCLUIDO_DECLARADO": "El proveedor lo declara excluido"
  },
  "cotizador": {
    "titulo": "Cotizador",
    "margen": "Margen",
    "costo": "Costo",
    "venta": "Venta",
    "total": "Total",
    "requiereAprobacion": "Requiere aprobación: margen bajo el piso",
    "sinRegla": "Sin regla aplicable: revisar configuración",
    "esEstimado": "Estimado: el cargo venía en rango",
    "tarifaElegida": "Tarifa elegida",
    "cliente": "Cliente",
    "eligeCliente": "Elige un cliente",
    "unidades": "Contenedores",
    "crear": "Crear cotización",
    "creando": "Creando…",
    "cancelar": "Cancelar",
    "folio": "Folio",
    "validaHasta": "Válida hasta",
    "idiomaDocumento": "Idioma del documento",
    "lineas": "Líneas",
    "codigo": "Código",
    "concepto": "Concepto",
    "descripcionLiteral": "Descripción del proveedor",
    "pisoAplicado": "Piso aplicado",
    "motivoAprobacion": "Motivo",
    "condicionesARevisar": "Condiciones que tienes que revisar",
    "cargosNoValorados": "Cargos que no se pudieron valorar",
    "sinCostos": "Tu usuario no ve costos: se muestran venta y totales de venta.",
    "otra": "Cotizar otra tarifa",
    "margenPct": "Margen sobre venta"
  },
  "tarifa": {
    "diasLibresDemora": "Días libres de demora",
    "diasLibresDetencion": "Días libres de detención",
    "transito": "Tránsito",
    "dias": "días",
    "noOfrecido": "No ofrecido",
    "sinVerificar": "Sin verificar: no cotizable"
  },
  "error": {
    "titulo": "La petición no se pudo completar",
    "red": "No se pudo hablar con la API. ¿Está levantada con npm run dev:api?",
    "ENTRADA_INVALIDA": "Petición inválida",
    "DESAMBIGUACION_REQUERIDA": "Hay que elegir",
    "SIN_RESOLVER": "No resuelve contra el catálogo",
    "TARIFA_NO_COTIZABLE": "Esta tarifa no se puede cotizar",
    "EQUIPO_NO_OFRECIDO": "La tarifa no ofrece ese equipo",
    "RECURSO_NO_ENCONTRADO": "No encontrado",
    "RUTA_NO_ENCONTRADA": "Ruta no encontrada",
    "ERROR_INTERNO": "Error interno de la API",
    "NO_AUTENTICADO": "Se cerró la sesión",
    "PROHIBIDO": "No tienes permiso para esto",
    "CREDENCIALES_INVALIDAS": "No se pudo entrar",
    "CAMBIO_DE_CONTRASENA_PENDIENTE": "Falta elegir tu contraseña"
  },
  "mapa": {
    "alt": "Ruta de {pol} a {pod}",
    "ver": "Ver el mapa de la ruta",
    "ocultar": "Ocultar el mapa de la ruta",
    "sinCoordenadas": "No hay coordenadas en el catálogo para {puertos}, así que la ruta no se dibuja. El resto de los datos no cambia."
  },
  "rfq": {
    "titulo": "Pedir cotización a proveedores",
    "desdeVacio": "Pedir cotización a proveedores",
    "explicaVacio": "Si el catálogo no tiene esta ruta, se le pregunta a los proveedores que la cubren. La ruta que buscaste ya va cargada.",
    "ruta": "Ruta",
    "volver": "Volver a la búsqueda",
    "abrirLista": "Solicitudes",
    "remitente": "Enviar desde",
    "remitenteAGS": "AGS",
    "remitenteFREIGHT_BRIDGE": "Freight Bridge (buzón propio, aún no existe)",
    "carga": {
      "titulo": "Qué carga se pide",
      "equipo": "Equipo",
      "unidades": "Cantidad",
      "mercancia": "Mercancía",
      "mercanciaAyuda": "Se manda tal como la escribas, sin traducir.",
      "peso": "Peso bruto (kg)",
      "volumen": "Volumen (m³)",
      "temperatura": "Temperatura (°C)",
      "fechaObjetivo": "Fecha objetivo de embarque",
      "requisitos": "Requisitos",
      "requisitosAyuda": "Temperatura, apilado, mercancía peligrosa, lo que haga falta.",
      "nota": "Nota interna"
    },
    "proveedores": {
      "titulo": "A quién se le pregunta",
      "cubren": "Cubren esta ruta",
      "noCubren": "No cubren esta ruta según su especialidad",
      "sinEspecialidad": "Sin especialidad declarada",
      "explicaNoCubren": "Se muestran igual: lo que sabemos de su alcance puede estar incompleto, y esconderlos haría imposible añadir al que sí la hace.",
      "sinCorreo": "Sin correo en el directorio: no se le puede escribir.",
      "ninguno": "No hay proveedores en el directorio.",
      "elegidos": {
        "uno": "1 proveedor elegido",
        "otro": "{n} proveedores elegidos"
      },
      "eligeUno": "Elige al menos un proveedor con correo."
    },
    "coincidencia": {
      "PUERTO": "Puerto exacto",
      "PAIS": "País",
      "REGION": "Región"
    },
    "crear": "Preparar solicitud",
    "creando": "Preparando…",
    "cancelar": "Cancelar",
    "folio": "Folio",
    "correo": {
      "titulo": "Correo listo para enviar",
      "explica": "Se redacta uno por idioma: cada proveedor lo recibe en el suyo. Cópialo, pégalo en tu cliente de correo y marca la solicitud como enviada.",
      "asunto": "Asunto",
      "cuerpo": "Cuerpo",
      "para": "Para",
      "copiarAsunto": "Copiar asunto",
      "copiarCuerpo": "Copiar cuerpo",
      "copiado": "Copiado",
      "copiaManual": "El navegador no dejó copiar: el texto está seleccionado, usa Ctrl+C.",
      "idioma": "Idioma del correo"
    },
    "integracion": "El envío automático por Microsoft Graph todavía no existe. Hoy la API redacta y registra; el correo lo mandas tú, y por eso «marcar como enviada» es una afirmación tuya y no del sistema.",
    "marcarEnviada": "Marcar como enviada",
    "marcando": "Marcando…",
    "cerrar": "Cerrar solicitud",
    "destinatarios": "Destinatarios",
    "enviadoEn": "Enviado",
    "sinEnviar": "Sin enviar",
    "respuestas": {
      "titulo": "Respuestas",
      "ninguna": "Todavía no ha contestado nadie.",
      "proveedor": "Proveedor",
      "eligeProveedor": "Elige el proveedor que contestó",
      "registrar": "Registrar respuesta",
      "registrando": "Registrando…",
      "sinOferta": "Contestó que no cubre la ruta o no ofrece",
      "nota": "Nota",
      "rateSheet": "Rate sheet cargado",
      "sinRateSheet": "Sin rate sheet todavía",
      "respondidaEn": "Contestó",
      "soloEnviadas": "La solicitud tiene que estar enviada para poder registrar respuestas."
    },
    "lista": {
      "titulo": "Solicitudes de cotización",
      "vacia": "No hay ninguna solicitud abierta.",
      "vaciaTodas": "Todavía no se ha creado ninguna solicitud.",
      "verAbiertas": "Solo abiertas",
      "verTodas": "Todas",
      "folio": "Folio",
      "ruta": "Ruta",
      "estado": "Estado",
      "destinatarios": "Proveedores",
      "sinResponder": "Falta respuesta",
      "creada": "Creada",
      "enviada": "Enviada",
      "abrir": "Abrir",
      "nueva": "Nueva solicitud"
    },
    "estado": {
      "BORRADOR": "Borrador",
      "ENVIADA": "Enviada",
      "CON_RESPUESTAS": "Con respuestas",
      "CERRADA": "Cerrada"
    }
  },
  "alta": {
    "abrirLista": "Altas",
    "estado": {
      "PENDIENTE": "Pendiente",
      "APROBADA": "Aprobada",
      "RECHAZADA": "Rechazada"
    },
    "lista": {
      "titulo": "Altas de proveedor",
      "verTodas": "Ver también las ya revisadas",
      "cargando": "Cargando la cola…",
      "vacia": "No hay solicitudes esperando. Las que llegan por el formulario público aparecen aquí."
    },
    "col": {
      "folio": "Folio",
      "empresa": "Empresa",
      "correo": "Correo",
      "modos": "Modos",
      "recibida": "Recibida",
      "estado": "Estado"
    },
    "senal": {
      "conocidoCorto": "Ya en la agenda",
      "conocido": "Ese correo ya está en el directorio:",
      "homonimo": "Ya hay un tercero con ese nombre:",
      "licencia": "Ese número de membresía ya lo tiene otro tercero:",
      "otras": {
        "uno": "Hay 1 solicitud más del mismo correo esperando.",
        "otro": "Hay {n} solicitudes más del mismo correo esperando."
      }
    },
    "bloque": {
      "dijo": "Lo que declaró",
      "decidir": "Qué se va a crear"
    },
    "campo": {
      "empresa": "Empresa",
      "pais": "País",
      "sitio": "Sitio web",
      "contacto": "Contacto",
      "correo": "Correo",
      "telefono": "Teléfono",
      "idioma": "Idioma",
      "recibida": "Recibida",
      "modos": "Modos",
      "trades": "Trades",
      "membresias": "Membresías",
      "revisada": "Revisada",
      "revisor": "Revisada por",
      "tercero": "Proveedor creado",
      "motivo": "Motivo del rechazo"
    },
    "decidir": {
      "enganchar": "Añadir al proveedor que ya existe:",
      "nombre": "Nombre en el directorio",
      "pais": "País (ISO)",
      "paisAyuda": "Dos letras, o vacío. El formulario pide el país en texto libre y aquí es donde se normaliza.",
      "especialidades": "Especialidades que se van a crear",
      "sinEspecialidades": "Ninguna: sólo declaró la ruta en texto libre. Se guarda como alcance del proveedor y las especialidades se añaden a mano.",
      "motivo": "Motivo (para rechazar)",
      "motivoAyuda": "Obligatorio para rechazar. Un rechazo sin motivo es una decisión que nadie puede explicar después.",
      "aprobar": "Aprobar y crear",
      "rechazar": "Rechazar",
      "volver": "Volver a la cola"
    },
    "hecho": {
      "creado": "Se creó el proveedor",
      "enganchado": "Se completó el proveedor que ya existía",
      "especialidades": "Especialidades creadas: {n}. Ya estaban: {repetidas}.",
      "licencias": {
        "uno": "Se registró 1 membresía.",
        "otro": "Se registraron {n} membresías."
      },
      "omitida": {
        "SIN_NUMERO": "no se registró, vino sin número",
        "YA_REGISTRADA": "no se registró, ese número ya lo tiene otro tercero"
      },
      "tradesRaros": "Trades que no existen en el catálogo y no se usaron: {t}"
    }
  },
  "login": {
    "titulo": "Entrar",
    "intro": "Usa el correo de la empresa. Si es tu primera vez, pídele la contraseña inicial a un administrador.",
    "email": "Correo",
    "contrasena": "Contraseña",
    "entrar": "Entrar",
    "entrando": "Entrando…",
    "sinAcceso": "¿Sin acceso o contraseña olvidada? Escríbele a un administrador: el cambio se hace desde dentro, no por correo.",
    "lema": "Tarifas, espacio y cotizaciones de carga internacional, en un solo sitio.",
    "caducada": "La sesión terminó. Vuelve a entrar para seguir donde estabas."
  },
  "usuarios": {
    "abrir": "Usuarios",
    "titulo": "Usuarios",
    "nuevo": "Nuevo usuario",
    "crear": "Crear usuario",
    "cancelar": "Cancelar",
    "cargando": "Cargando usuarios…",
    "vacia": "No hay ningún usuario.",
    "elige": "Elige…",
    "tu": "tú",
    "activo": "Activo",
    "inactivo": "De baja",
    "sinClave": "Sin contraseña",
    "darBaja": "Dar de baja",
    "reactivar": "Reactivar",
    "rol": {
      "AGENTE": "Agente",
      "SUPERVISOR": "Supervisor",
      "OPERADOR": "Operador",
      "ADMIN": "Administrador"
    },
    "rolDetalle": {
      "AGENTE": "Cotiza y pide precio a proveedores.",
      "SUPERVISOR": "Todo lo del agente, más las reglas de margen y las cotizaciones de todo el equipo.",
      "OPERADOR": "Mantiene el catálogo: firma tarifas, resuelve alias, revisa altas de proveedor. No cotiza.",
      "ADMIN": "Todo lo anterior, más el alta y la baja de usuarios."
    },
    "veCosto": {
      "si": "Ve costos",
      "no": "No ve costos"
    },
    "col": {
      "nombre": "Nombre",
      "email": "Correo",
      "rol": "Rol",
      "veCosto": "Costos",
      "estado": "Estado",
      "sesiones": "Sesiones / contraseña",
      "acciones": "Acciones"
    },
    "campo": {
      "nombre": "Nombre",
      "email": "Correo",
      "rol": "Rol",
      "veCosto": "¿Ve los costos del proveedor?",
      "contrasena": "Contraseña inicial"
    },
    "ayuda": {
      "rol": "El rol decide a qué zonas llega esta persona. No decide si ve costos: eso es la pregunta de abajo, y son cosas distintas.",
      "veCosto": "Decide si los montos del catálogo y los costos de una cotización llegan hasta esta persona. No se elige por defecto.",
      "contrasena": "Déjala vacía y el sistema genera una: doce caracteres sin ceros ni oes, pensados para dictarse. Se muestra una sola vez. Si escribes una, mínimo {n} caracteres."
    },
    "alta": {
      "titulo": "Dar de alta a alguien"
    },
    "reseteo": {
      "abrir": "Cambiar contraseña",
      "etiqueta": "Nueva contraseña de {nombre}",
      "confirmar": "Cambiar y cerrar sus sesiones",
      "ayuda": "Déjala vacía y se genera una, que verás una sola vez. Al cambiarla se cierran todas sus sesiones abiertas, aquí y en cualquier otro navegador, y tendrá que elegir una nueva al entrar. No se deshace."
    },
    "aviso": {
      "creado": "{nombre} ya puede entrar. Dile su contraseña por un medio que no sea esta pantalla.",
      "baja": "{nombre} queda de baja y sus sesiones se cerraron.",
      "reactivado": "{nombre} vuelve a poder entrar.",
      "reseteada": "Contraseña de {nombre} cambiada. Sesiones cerradas: {n}."
    },
    "claveTemporal": "clave temporal",
    "claveTemporalAyuda": "Todavía no ha elegido su contraseña: la que tiene se la dictaron. La cambiará la primera vez que entre.",
    "nSesiones": {
      "uno": "1 sesión abierta",
      "otro": "{n} sesiones abiertas"
    },
    "contrasenaDesde": "Contraseña desde el {fecha}",
    "contrasenaSinFecha": "Contraseña sin fecha de cambio"
  },
  "menu": {
    "titulo": "Zonas",
    "alternar": "Abrir o cerrar el menú"
  },
  "zona": {
    "cotizar": {
      "nombre": "Buscar y cotizar",
      "descripcion": "Busca tarifas vigentes por ruta, modo y equipo, y convierte la que elijas en una cotización con folio."
    },
    "cotizaciones": {
      "nombre": "Cotizaciones",
      "descripcion": "Las cotizaciones ya emitidas, con su folio, su cliente y sus montos tal como salieron. No se recalculan."
    },
    "rfq": {
      "nombre": "Solicitudes RFQ",
      "descripcion": "Pedir precio a proveedores cuando el catálogo no tiene la ruta. La API redacta el correo; enviarlo lo hace una persona."
    },
    "tarifas": {
      "nombre": "Tarifas",
      "descripcion": "Las dos colas del catálogo: documentos esperando firma y alias que la ingesta no supo resolver.",
      "pendientes": "{n} documento(s) listos para firmar"
    },
    "proveedores": {
      "nombre": "Proveedores",
      "descripcion": "El directorio al que se manda un RFQ, y la cola de quienes pidieron entrar por el formulario público.",
      "pendientes": "{n} solicitud(es) de alta sin revisar"
    },
    "administracion": {
      "nombre": "Administración",
      "descripcion": "Altas y bajas de usuarios, y las reglas de margen con las que se calcula cada cotización."
    },
    "ayuda": {
      "nombre": "Ayuda",
      "descripcion": "Qué hace cada zona y cómo se usa. Empieza por aquí si es tu primer día."
    }
  },
  "ayuda": {
    "intro": "Esto es lo que puedes hacer con tu cuenta y por qué la aplicación se comporta como se comporta. Si echas en falta una zona, es que tu rol no la incluye: pídesela a un administrador.",
    "indice": "Secciones de la ayuda",
    "buscar": {
      "titulo": "Cómo se busca",
      "intro": "El buscador consulta el catálogo de tarifas que llegaron por correo, ya normalizadas. Solo salen las que un compañero verificó y que están vigentes para la fecha que pides: el catálogo casi siempre tiene más de las que ves, y la sección de abajo explica por qué se quedan fuera.",
      "modos": "Marítimo y aéreo son dos formularios distintos",
      "maritimo": "En marítimo pides puerto de carga, puerto de descarga, equipo y fecha. El precio va por contenedor, así que el equipo es lo que decide qué tarifa aplica y con qué días libres.",
      "aereo": "En aéreo no hay equipo —una tarifa aérea no ofrece cajas— y en su lugar pides el peso real y el volumen. Los dos son obligatorios: el precio va por kilo y el número de kilos que se cobran sale de comparar los dos. Los bultos son opcionales y no cambian el precio; sirven para contrastar los límites por pieza de cada tarifa.",
      "fecha": "La fecha de embarque no se supone",
      "fechaPorQue": "Se pide siempre y no se rellena con «hoy». La fecha decide qué tarifas están vigentes, y una tarifa que rige hasta fin de mes no sirve para embarcar la semana siguiente. Suponerla en silencio haría que la lista cambiara sin que nadie hubiera cambiado nada.",
      "pais": "El país de un puerto: por qué a veces hay que elegir",
      "paisPorQue": "Manzanillo existe en México y en Panamá. Cuando lo que escribes identifica más de un sitio, la búsqueda no se ejecuta: se paran las opciones en pantalla y eliges tú. No se toma la más probable ni se reintenta con la primera, porque elegir mal manda la carga al continente equivocado y nadie se entera hasta que es tarde. Elegir una sugerencia del autocompletado fija el país; editar el texto a mano después lo borra, porque un país pegado a un puerto que ya no es el que dice el campo es peor que no tener país.",
      "carga": "Qué es lo que viaja",
      "cargaPorQue": "La naturaleza de la carga se declara una vez, debajo del buscador, y viaja a la cotización y al correo del RFQ. Refrigerada pide temperatura; peligrosa pide clase IMO y número UN, y la cotización sale marcada; sobredimensionada pide las tres medidas. Cambiar de naturaleza no arrastra los datos de la anterior: lo que no aplica no viaja.",
      "noFiltra": "Declarar la carga NO esconde tarifas, y es deliberado. Lo único que hace con el catálogo es poner los equipos reefer delante cuando la carga es refrigerada. Descartar tarifas por mercancía peligrosa o comprobar que las medidas quepan necesita datos que el catálogo no tiene, y sin ellos el filtro se inventaría el criterio: un buscador que esconde tarifas por una regla inventada es peor que uno que las enseña todas, porque lo que no aparece no se puede revisar."
    },
    "resultados": {
      "titulo": "Cómo se leen los resultados",
      "intro": "La lista no es una lista: son grupos, y dentro de cada uno las tarifas van ordenadas por total. El orden es del servidor y la pantalla no lo toca.",
      "grupos": "Por qué hay varios grupos y no una tabla",
      "gruposPorQue": "Las tarifas se agrupan por alcance y término de entrega, y solo se comparan dentro de su grupo. Una tarifa que no declara qué incluye tiene el total más bajo porque le faltan cargos, no porque sea más barata; y una entrega en patio y una en puerta no son el mismo producto. Puestas en la misma columna se comparan solas aunque nadie las haya ordenado juntas, así que van separadas y etiquetadas.",
      "avisos": "Los avisos de cada tarifa",
      "avisosPorQue": "Bajo cada fila hay una banda con lo que hay que leer antes de decidir. Los rojos dicen que la tarifa no se puede usar tal como está; los ámbar, que el número de al lado puede no significar lo que parece. Junto a cada aviso va el texto del proveedor, sin traducir ni limpiar: la interpretación puede estar mal, el texto original no. Estos son todos:",
      "costos": "Si no ves los importes",
      "costosPorQue": "La visibilidad de costos es una propiedad de tu cuenta, no de la tarifa. Cuando tu usuario no ve costos, los importes no salen del servidor: no están ocultos en la página, no llegaron. Lo que sí llega son los términos completos —carrier, tránsito, días libres, alcance, vigencia, y el código, tramo y base de cada cargo— y el orden por precio se mantiene, porque el orden relativo no es el número. Un campo que falta se dice con palabras, nunca con un cero ni una celda vacía."
    },
    "peso": {
      "titulo": "El peso que se cobra (aéreo)",
      "intro": "En aéreo, los kilos que se facturan casi nunca son los de la báscula. Es la diferencia que más sorprende al cliente, y la que el agente tiene que poder explicar sin llamar a nadie.",
      "cual": "Se cobra el mayor de los dos",
      "cualPorQue": "El volumen se convierte a kilos con una relación que es un dato de cada tarifa —6000 cm³/kg es la de IATA, y una promoción «1:500» son 2000— y se cobra el mayor entre ese peso volumétrico y el real. La pantalla enseña los tres números y dice cuál mandó. Cuando la tarifa no declara con qué relación convertir, no se cotiza: suponer la de IATA sería inventar el precio.",
      "ejemplo": "Una carga de 120 kg en 3 m³ paga 500 kilos con la relación de IATA: manda el volumétrico. La misma carga con una promoción 1:500 pagaría 1500. Ninguna columna de precio cambia; lo que cambia es cuántos kilos multiplican.",
      "escalon": "El escalón decide el precio del kilo",
      "escalonPorQue": "Una fila aérea trae varios precios —+45, +100, +300, +500, +1000— y el peso que se cobra elige cuál aplica. Los otros no desaparecen de la cotización: salen aparte, con el motivo, porque un escalón que se esfuma es indistinguible de uno que vale cero. El tope de un escalón no entra: 500 kilos justos pagan el que empieza en 500. Y si el proveedor dejó una barra en el escalón que te toca, esa tarifa no sirve a ese peso: no se cae al escalón vecino, que sería cobrar un precio que nadie dio.",
      "bultos": "Los límites por bulto",
      "bultosPorQue": "Algunas tarifas limitan el tamaño o el peso por pieza. Si declaras cuántos bultos son —y sus medidas, cuando la carga es sobredimensionada— la búsqueda contrasta y marca en rojo las tarifas que no los aceptan, con los dos números por los que fallan. La tarifa sigue en la lista y se puede cotizar: la decisión es tuya. Solo se marca lo que es seguro: un bulto que cabe girado no se marca, y un peso medio por pieza por debajo del tope tampoco, aunque las piezas puedan ser desiguales. Cuando no hay con qué comparar, lo dice: «no se pudo comprobar» no es lo mismo que «cabe»."
    },
    "cotizar": {
      "titulo": "Cómo se cotiza y qué queda congelado",
      "intro": "Cotizar convierte una tarifa del catálogo en un documento con folio. A partir de ahí, los importes son los que la empresa está obligada a honrar.",
      "congela": "Los importes se congelan",
      "congelaPorQue": "El costo, la venta y la tasa de cambio quedan fijos en el momento de crear la cotización. Releerla mañana no la recalcula, aunque el proveedor haya mandado precios nuevos o alguien haya movido una regla de margen: lo que se envió al cliente es lo que queda escrito. En aéreo se congela además la anatomía completa —el peso que se cobró, con qué relación se convirtió el volumen, qué escalón se aplicó y a qué precio por kilo— para que la factura se pueda explicar un año después.",
      "noValorados": "Cargos que no entran al total",
      "noValoradosPorQue": "Algunos cargos no se pueden convertir en una línea con importe, y ninguno se omite en silencio: viajan en la cotización con su texto original y su motivo. Un cargo que desaparece sin dejar rastro es indistinguible de un cargo que vale cero. Estos son los motivos:",
      "aprobacion": "Cuando pide aprobación",
      "aprobacionPorQue": "El margen se valida sobre el total de la opción, no cargo por cargo. Si queda por debajo del piso, la cotización se emite igual pero marcada, con el piso que se aplicó. Ese veredicto también se congela: una cotización que salió sin firma pendiente no empieza a necesitarla porque alguien mueva el piso después."
    },
    "vacio": {
      "titulo": "Cuando no sale ninguna tarifa",
      "intro": "Cero resultados casi nunca significa que la ruta no exista. La pantalla dice cuántas tarifas hay cargadas para esa ruta y por qué ninguna llegó a la lista, ordenadas por lo que se arregla antes. Cada motivo se arregla de una forma distinta:"
    },
    "zonas": {
      "titulo": "Dónde estás",
      "intro": "Las zonas que abre tu cuenta. El menú no es la cerradura: una zona que no aparece sigue siendo alcanzable escribiendo su dirección, y lo que contesta entonces es la API con un 403. El menú existe para no enseñar puertas que no abren."
    }
  },
  "cotizaciones": {
    "col": {
      "folio": "Folio",
      "cliente": "Cliente",
      "ruta": "Ruta",
      "estado": "Estado",
      "venta": "Venta",
      "creada": "Creada",
      "agente": "Agente"
    },
    "abrir": "Abrir",
    "volver": "Volver a la lista",
    "tuya": "tuya",
    "soloMias": "Estás viendo solo tus cotizaciones.",
    "deTodos": "Estás viendo las cotizaciones de todo el equipo.",
    "vacia": "Todavía no hay ninguna cotización.",
    "vaciaComo": "Se crean desde Buscar y cotizar: busca una ruta, elige una tarifa y pulsa Cotizar.",
    "sinRuta": "Ruta no disponible",
    "sinTotal": "Sin total",
    "requiereAprobacion": "Necesita aprobación",
    "enviada": "Enviada al cliente",
    "sinEnviar": "Todavía no se ha enviado",
    "diasLibres": "Días libres",
    "opcionSinEtiqueta": "Opción",
    "veredictoAusente": "De esta cotización no consta si necesitaba aprobación: se emitió antes de que eso se guardara. No significa que no la necesitara.",
    "conEstimados": "Algún cargo venía en rango y se tomó el techo: el total es una estimación por arriba."
  },
  "tarifas": {
    "intro": "Las dos colas de las que depende que el buscador tenga algo que devolver.",
    "firmar": "Firmar",
    "firmando": "Firmando…",
    "firmado": "Documento firmado. Tarifas cotizables ahora: {n}.",
    "sinAsunto": "Sin asunto",
    "sinProveedor": "Proveedor no identificado",
    "bloqueadoSinMotivo": "No se puede firmar todavía.",
    "sheets": {
      "titulo": "Documentos esperando firma",
      "explicacion": "Una tarifa sin verificar no llega a ninguna cotización. Firmar es decir que has leído el documento y respondes de él; a partir de ahí sus tarifas se pueden cotizar.",
      "vacia": "No hay ningún documento pendiente de verificar.",
      "documento": "Documento",
      "proveedor": "Proveedor",
      "estado": "Estado",
      "tarifas": "Tarifas",
      "sinFlete": "Sin flete",
      "recibido": "Recibido"
    },
    "alias": {
      "titulo": "Alias sin confirmar",
      "explicacion": "Palabras que llegaron en un correo y la ingesta no supo resolver sola. Cada una bloquea las filas que la usan.",
      "vacia": "No hay ningún alias pendiente.",
      "comoSeDespacha": "Confirmar un alias cambia el catálogo para siempre y para todos, así que no se hace desde aquí: entra como migración, igual que cualquier otro cambio del catálogo. Esta cola es para saber qué hay pendiente y qué está bloqueando.",
      "tipo": "Catálogo",
      "alias": "Como vino escrito",
      "resuelveA": "Apunta a",
      "proveedor": "Proveedor",
      "bloqueadas": "Bloquea",
      "aNada": "no apunta a nada",
      "aRevisar": "acrónimo sin glosario",
      "confianza": "confianza",
      "global": "todos",
      "catalogo": {
        "codigo_cargo": "Código de cargo",
        "equipo": "Equipo",
        "ubicacion": "Ubicación"
      },
      "estado": {
        "PROPUESTO": "Propuestos, esperando firma",
        "SIN_RESOLVER": "Sin resolver"
      },
      "ayuda": {
        "PROPUESTO": "Tienen destino y solo falta confirmarlos. Cada uno que se firme desbloquea las tarifas que lo usaban.",
        "SIN_RESOLVER": "No apuntan a nada, o apuntan al centinela REVISAR. Firmar no los arregla: hace falta una decisión de negocio o alguien que conozca el dominio."
      }
    }
  },
  "estadoParseo": {
    "PENDIENTE": "Pendiente",
    "CLASIFICADO": "Clasificado",
    "EXTRAIDO": "Extraído",
    "VERIFICADO": "Verificado",
    "RECHAZADO": "Rechazado",
    "BLOQUEADO_DEPENDENCIA": "Bloqueado por dependencia"
  },
  "proveedores": {
    "pestana": {
      "directorio": "Directorio",
      "altas": "Solicitudes de alta"
    },
    "directorio": {
      "titulo": "Directorio de proveedores",
      "intro": "A quién tenemos, con qué correo, en qué idioma y para qué tráfico. Es la agenda a la que se manda un RFQ."
    },
    "buscar": "Buscar por nombre",
    "buscarAccion": "Buscar",
    "buscarPlaceholder": "Parte del nombre de la empresa",
    "vacio": "El directorio está vacío.",
    "vacioBusqueda": "Ningún proveedor coincide con «{q}».",
    "vacioComo": "Los proveedores entran por el formulario público de alta y su cola de revisión.",
    "irAAltas": "Ver la cola de solicitudes",
    "hayMas": "Hay más proveedores de los que caben aquí. Afina la búsqueda para verlos.",
    "noIdentificado": "empresa sin identificar",
    "sinCorreo": "sin correo",
    "sinCorreoAyuda": "Ningún contacto activo tiene dirección de correo, así que no aparecerá al preparar un RFQ.",
    "resumen": "{contactos} contacto(s) · {especialidades} especialidad(es) · {sheets} documento(s)",
    "ver": "Ver ficha",
    "cerrar": "Cerrar ficha",
    "contactos": "Contactos",
    "sinContactos": "No hay ningún contacto activo.",
    "sinNombre": "Sin nombre",
    "sinEmail": "Sin correo",
    "recibeRfq": "recibe RFQ",
    "especialidades": "Especialidades",
    "sinEspecialidades": "No tiene ninguna especialidad declarada, así que no se propone al preparar un RFQ de ninguna ruta."
  },
  "margenes": {
    "titulo": "Márgenes",
    "intro": "Con qué se calcula el precio de venta de cada línea, y por debajo de qué margen una cotización necesita aprobación. Cambiar esto cambia lo que se cotice a partir de ahora; lo ya emitido no se mueve.",
    "verActivas": "Solo las vigentes",
    "verTodas": "Con el histórico",
    "inactiva": "retirada",
    "sustituye": "sustituye a otra",
    "editar": "Cambiar",
    "desactivar": "Retirar",
    "reactivar": "Reactivar",
    "crear": "Crear",
    "cancelar": "Cancelar",
    "guardarSustituyendo": "Guardar como versión nueva",
    "cualquiera": "Cualquiera",
    "aplicaATodo": "Todas las líneas",
    "porUnidad": "unidad",
    "porMigracion": "por migración",
    "desgloseGlobal": "0 — no acota ninguna dimensión, así que es la que se aplica cuando ninguna otra encaja.",
    "dondeAplica": "Dónde se aplica",
    "dondeAplicaAyuda": "Cada campo que rellenes acota la regla y la hace más específica. La más específica de las que encajen es la que gana; en empate, la más reciente.",
    "reglas": {
      "titulo": "Reglas de markup",
      "explicacion": "Convierten el costo del proveedor en precio de venta. Se listan de más específica a menos, que es el orden en que el motor las mira.",
      "nueva": "Nueva regla",
      "editar": "Cambiar una regla",
      "vacia": "No hay ninguna regla. Sin reglas, el motor cotiza a costo y marca cada línea como SIN_REGLA."
    },
    "pisos": {
      "titulo": "Pisos de margen",
      "explicacion": "Por debajo de este margen, la cotización sale marcada como que necesita aprobación. Se valida sobre el total de la opción, nunca línea por línea.",
      "nuevo": "Nuevo piso",
      "editar": "Cambiar un piso",
      "vacio": "No hay ningún piso. Sin piso, ninguna cotización pide aprobación nunca."
    },
    "col": {
      "descripcion": "Descripción",
      "aplicaA": "Se aplica a",
      "especificidad": "Espec.",
      "tipo": "Tipo",
      "valor": "Valor",
      "minimo": "Mínimo",
      "cambio": "Quién y cuándo"
    },
    "campo": {
      "descripcion": "Descripción",
      "tipo": "Tipo de cálculo",
      "valor": "Valor",
      "modo": "Modo",
      "tramo": "Tramo",
      "codigoCargo": "Código de cargo",
      "cliente": "Cliente",
      "vigenciaDesde": "Vigente desde",
      "vigenciaHasta": "Vigente hasta",
      "minPct": "Margen mínimo (fracción)",
      "minAbs": "Margen mínimo (monto)"
    },
    "ayuda": {
      "descripcionRegla": "Es lo único que explica esta regla a quien la lea dentro de tres meses. Di el porqué, no el qué: «flete FCL a 5% acordado con dirección en agosto» sirve; «regla 3» no.",
      "descripcionPiso": "Aparece en pantalla al lado de «necesita aprobación», y es lo único que le dice al agente qué hacer.",
      "valorFraccion": "Se escribe como fracción: 0.08 es un 8%.",
      "valorMonto": "Monto por unidad, en la moneda de la tarifa.",
      "minPct": "Fracción del total de venta: 0.04 es un 4%. Déjalo vacío si solo quieres un mínimo en monto.",
      "minAbs": "Monto mínimo de margen, en la moneda de venta. Opcional.",
      "codigoCargo": "Un código que ya exista en el catálogo (OFR, THC, BAF…). No se inventan códigos: si no existe, la base rechaza la regla.",
      "cliente": "Un acuerdo con un cliente concreto siempre manda sobre una política general.",
      "vigencia": "Fuera de estas fechas la regla no se aplica. Vacío en «hasta» significa sin fecha de fin."
    },
    "ayudaTipo": {
      "PORCENTAJE": "venta = costo × (1 + valor). El markup de toda la vida.",
      "FIJO_UNIDAD": "venta = costo + valor × unidades. Un recargo fijo por contenedor.",
      "VENTA_FIJA": "venta = valor × unidades. Precio cerrado: ignora el costo por completo.",
      "MARGEN_OBJETIVO": "venta = costo ÷ (1 − valor). El valor es la fracción de la venta que quieres que quede como margen.",
      "SIN_MARGEN": "venta = costo. Se cotiza al costo, sin margen y sin que parezca un olvido."
    },
    "dim": {
      "cliente": "Cliente",
      "ruta": "Ruta",
      "trade": "Trade",
      "cargo": "Cargo",
      "tramo": "Tramo",
      "modo": "Modo"
    },
    "tipo": {
      "PORCENTAJE": "Porcentaje",
      "FIJO_UNIDAD": "Fijo por unidad",
      "VENTA_FIJA": "Venta fija",
      "MARGEN_OBJETIVO": "Margen objetivo",
      "SIN_MARGEN": "Sin margen"
    },
    "sustitucion": {
      "titulo": "Esto no edita la regla: crea una versión nueva.",
      "explicacion": "La regla actual queda retirada y nace una que la sustituye. Es a propósito: las cotizaciones ya emitidas apuntan a la regla que usaron, y cambiarla en sitio haría que su explicación dijera otra cosa. El histórico se conserva entero."
    },
    "aviso": {
      "creada": "Regla creada: {d}. Se aplica a partir de la próxima cotización.",
      "sustituida": "Versión nueva guardada: {d}. La anterior queda retirada y sigue explicando las cotizaciones que la usaron.",
      "creado": "Piso creado: {d}.",
      "sustituido": "Versión nueva guardada: {d}. El piso anterior queda retirado.",
      "activada": "{d} vuelve a aplicarse.",
      "desactivada": "{d} queda retirada. Deja de aplicarse a partir de ahora."
    }
  },
  "lote": {
    "abrir": "Dar de alta a varios",
    "titulo": "Alta de varios usuarios",
    "explicacion": "Una fila por persona. Las contraseñas las genera el sistema y se muestran una sola vez, al terminar. Si algo falla, no se crea ninguno: se corrige y se vuelve a mandar.",
    "anadirFila": "Añadir otra fila",
    "quitarFila": "Quitar",
    "quitarFilaN": "Quitar la fila {n}",
    "crear": "Crear los {n}",
    "creando": "Creando…",
    "faltan": "Faltan datos en las filas marcadas. Cada persona necesita nombre, correo y una respuesta a si ve los costos.",
    "unaVez": {
      "titulo": "Estas contraseñas se ven una sola vez.",
      "explicacion": "No se guardan en ningún sitio: lo que queda es su huella. Si cierras esta pantalla sin copiarlas, la única salida es cambiárselas una por una."
    },
    "credenciales": {
      "titulo": "{n} usuario(s) creado(s)",
      "contrasena": "Contraseña temporal",
      "laElegiste": "la elegiste tú"
    },
    "copiarTodas": "Copiar todas",
    "copiado": "Copiado. Pégalo donde se lo vayas a pasar.",
    "copiaManual": "Este navegador no deja copiar solo. El texto está seleccionado abajo: pulsa Ctrl+C (o Cmd+C).",
    "cerrarYPerder": "Ya las copié, cerrar",
    "queHacenEllos": "Cada persona entra con su correo y esta contraseña, y lo primero que verá es la pantalla para elegir la suya. Hasta que lo haga no llega a nada más."
  },
  "cambio": {
    "titulo": "Elige tu contraseña",
    "hola": "Hola, {nombre}.",
    "porQue": "La contraseña con la que acabas de entrar te la dio otra persona, así que la sabe alguien más. Elige la tuya antes de seguir; hasta entonces no se puede hacer nada más.",
    "actual": "La contraseña que te dieron",
    "actualAyuda": "Se pide aunque acabes de escribirla: es lo único que distingue a quien entró de quien se sentó delante de una pantalla sin bloquear.",
    "nueva": "Tu contraseña nueva",
    "nuevaAyuda": "Mínimo {n} caracteres. No hay más reglas: una frase corta que recuerdes vale más que algo con símbolos que acabes apuntando.",
    "repetida": "Repítela",
    "guardar": "Guardar y entrar",
    "guardando": "Guardando…",
    "noCoinciden": "Las dos contraseñas nuevas no son iguales.",
    "corta": "La contraseña nueva necesita al menos {n} caracteres.",
    "noSoyYo": "No soy yo, salir"
  },
  "carga": {
    "titulo": "¿Qué es lo que viaja?",
    "enCotizacion": "Carga declarada",
    "naturaleza": {
      "GENERAL": "Carga general",
      "REFRIGERADA": "Carga refrigerada",
      "PELIGROSA": "Mercancía peligrosa (IMO)",
      "SOBREDIMENSIONADA": "Carga sobredimensionada"
    },
    "ayuda": {
      "GENERAL": "Lo normal. No hace falta declarar nada más.",
      "REFRIGERADA": "Se pedirá la temperatura, y los equipos reefer se ponen primero en la lista. No se descarta ningún equipo: un 40NOR es un reefer que se usa como seco, y hay quien lo elige a propósito.",
      "PELIGROSA": "Se pedirán la clase IMO y el número UN. Van en la cotización, marcados, y en el correo al proveedor: sin ellos no puede cotizar y la carga se rechaza en puerta.",
      "SOBREDIMENSIONADA": "Se pedirán las tres medidas. Van al correo del proveedor, que es quien decide si cabe."
    },
    "campo": {
      "temperatura": "Temperatura (°C)",
      "imoClase": "Clase IMO",
      "imoUn": "Número UN",
      "largo": "Largo (cm)",
      "ancho": "Ancho (cm)",
      "alto": "Alto (cm)",
      "nota": "Nota sobre la carga"
    },
    "ayudaCampo": {
      "temperatura": "Entre -60 y 40. Si querías -18, revisa el signo.",
      "imoClase": "Como «3», «4.1», «5.2» u «8».",
      "imoUn": "Cuatro dígitos, con o sin el prefijo UN: «1203».",
      "dimensiones": "En centímetros. Las tres: con dos no se puede decidir si cabe."
    }
  },
  "experiencia": {
    "MARITIMO": "Marítimo",
    "AEREO": "Aéreo"
  },
  "dia": {
    "corto": {
      "1": "Lu",
      "2": "Ma",
      "3": "Mi",
      "4": "Ju",
      "5": "Vi",
      "6": "Sá",
      "7": "Do"
    },
    "largo": {
      "1": "Lunes",
      "2": "Martes",
      "3": "Miércoles",
      "4": "Jueves",
      "5": "Viernes",
      "6": "Sábado",
      "7": "Domingo"
    }
  },
  "aereo": {
    "porKg": "/kg",
    "porKgColumna": "Precio por kg",
    "sinPrecioPorKg": "Tu usuario no ve costos",
    "escalon": "escalón {etiqueta}",
    "rangoEntre": "De {desde} a {hasta} kg. El tope no entra: {hasta} kg justos pagan el escalón siguiente.",
    "rangoDesde": "Desde {desde} kg.",
    "rangoHasta": "Hasta {hasta} kg. El tope no entra.",
    "rangoSinCotas": "Sin escalones declarados.",
    "kg": "kg",
    "pesoTarifable": "Peso que se cobra",
    "volumetrico": "Volumétrico",
    "manda": {
      "VOLUMETRICO": "Manda el volumétrico: la carga pesa {real} kg y el volumen da {volumetrico} kg.",
      "REAL": "Manda el peso real: {real} kg de báscula contra {volumetrico} kg de volumen.",
      "EMPATE": "Los dos dan lo mismo: {real} kg de báscula y {volumetrico} kg de volumen."
    },
    "relacion": "Relación volumétrica: {valor} cm³/kg",
    "ruta": "Ruta",
    "escala": "escala",
    "sinItinerario": "La tarifa no declara escalas. No se supone un vuelo directo: es que el documento no lo dijo.",
    "trucking": "Por carretera",
    "alternativas": "El proveedor dejó abierto este punto:",
    "preacarreo": "Se recoge en el aeropuerto declarado y despega de {salida}, por carretera. El tránsito ya lo cuenta.",
    "frecuenciaSinInterpretar": "No se interpretó: lee el literal del proveedor.",
    "opera": "opera",
    "noOpera": "no opera",
    "maxLargo": "Largo máximo (m)",
    "maxAncho": "Ancho máximo (m)",
    "maxAlto": "Alto máximo (m)",
    "maxPesoPieza": "Peso máximo por pieza (kg)",
    "noApta": "No apta para estos bultos",
    "apta": "Los bultos declarados caben en los límites de esta tarifa.",
    "noComprobable": "No se pudo comprobar si los bultos caben: falta declararlos, o la tarifa no da los límites en números. Lee el texto del proveedor.",
    "incumple": {
      "MEDIDA_EXCEDIDA": "El bulto mide {declarado} m y no cabe en ninguna orientación: el máximo de esta tarifa es {limite} m.",
      "PESO_POR_PIEZA_EXCEDIDO": "El peso medio por pieza es {declarado} kg y el máximo de esta tarifa es {limite} kg."
    },
    "porQueEsePeso": "Por qué ese peso"
  }
}
